// Helpers for the mass update and mass complete on /trials (see MassUpdateReview.jsx)

export { apiErrorMessage } from "./apiError";

/** "1 trial" / "3 trials" */
export function trialCount(n) {
  return `${n} trial${n === 1 ? "" : "s"}`;
}

const TRI_STATE = { 0: "No", 1: "Yes", 2: "To be decided" };

/** Labels of the fields a mass update can change (the API's field names). */
export const MASS_FIELD_LABELS = {
  studydirector: "Study Director (SD)",
  FT: "Field Technician (FT)",
  PI: "Principal Investigator (PI)",
  crop_id: "Crop",
  country_id: "Country",
  host_id: "Host",
  study_type_id: "Study type",
  trial_type_id: "Trial type",
  TreatmentCount: "Treatment Count",
  ReplicationCount: "Replication Count",
  PlotSizeL: "Plot Size L",
  PlotSizeB: "Plot Size W",
  FieldFaseStart: "Field Phase Start",
  FieldFaseEnd: "Field Phase End",
  Harvest: "Harvest",
  NIT: "NIT",
  TGW: "TGW",
  GerminationTest: "Germination Test",
  NIT_Samples: "NIT Samples",
  GT_Samples: "Germination Test Samples",
  TGW_Samples: "TGW Samples",
  donedate: "Done date",
  bbch: "BBCH",
};

/**
 * A value as shown in the preview. `names` maps a field to a function giving the name of an id
 * (users, crops, countries); booleans are Yes/No, NIT/TGW/Germination Test/Harvest
 * Yes/No/To be decided, and empty is "(empty)".
 */
export function displayValue(field, value, names = {}) {
  if (value === null || value === undefined || value === "") return "(empty)";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (["NIT", "TGW", "GerminationTest", "Harvest"].includes(field) && TRI_STATE[value] !== undefined) return TRI_STATE[value];
  if (names[field]) return names[field](value) ?? String(value);
  return String(value);
}
